/**
 * Display-name helpers for the inspectors surface (AUT-125).
 *
 * The server sends `name` already redacted-or-full per `piiRevealed`.
 * These helpers only derive a short id from values the SPA already holds —
 * they never reconstruct PII. Avatar initials live in `utils/initials`.
 */

/** Truncate an inspector userId to the mockup's `insp_2b71…0e4` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
